import { buttonFragment, colouredTextFragment, systemFields } from 'petdna-lib-uicomponents/hygraph';

export const biopetUpdateCardQueryVariables = {
  id: 'cmj1hl05u72br08lcr5tetfbe',
};

export const biopetUpdateCardQuery = `query BiopetUpdateQuery($id: ID!) {
  biopetUpdateCard(where: { id: $id }) {
    ${systemFields}
    title {
      ${colouredTextFragment}
    }
    text {
      ${colouredTextFragment}
    }
    details {
      ${colouredTextFragment}
    }
    buttons {
      ${buttonFragment}
    }
    footer {
      ${colouredTextFragment}
    }
  }
}`;
